import React, { FC } from 'react';

import { EvTag, EvTitle } from '@evinced-private/ui-common';

import { StatusTag, TrendTag } from './types';

interface BaseCardProps {
	id: string;
	title: string;
	className: string;
	infoContent: string;
	ariaLabel: string;
}

interface ScoreCardProps extends BaseCardProps {
	type: 'score';
	score: number | null;
	maxScore?: number;
	statusTag: StatusTag;
}

interface MetricCardProps extends BaseCardProps {
	type: 'metric';
	value: string;
	trendTag: TrendTag;
	trendAriaLabel: string;
}

type AccessibilitySummaryCardProps = ScoreCardProps | MetricCardProps;

export const AccessibilitySummaryCard: FC<AccessibilitySummaryCardProps> = (props) => {
	const { id, title, className, infoContent, ariaLabel, type } = props;

	return (
		<div className={`summary-card ${className}`} role="group" aria-labelledby={`${id}-title`}>
			<div className="card-header">
				<EvTitle
					id={`${id}-title`}
					titleText={title}
					headingLevel={3}
					className="card-title"
					MoreInfoContent={<div>{infoContent}</div>}
				/>
			</div>
			<div className="card-content">
				{type === 'score' ? (
					<>
						<div className="score-display">
							<span className="score-value" aria-label={ariaLabel}>
								{props.score === null ? '0' : props.score}
							</span>
							{props.score !== null && props.maxScore && (
								<span className="score-denominator" aria-hidden="true">
									/{props.maxScore}
								</span>
							)}
						</div>
						<EvTag
							status={props.statusTag.status}
							text={props.statusTag.text}
							aria-label={`Status: ${props.statusTag.text}`}
						/>
					</>
				) : (
					<div className="metric-value-container">
						<span className="metric-value" aria-label={ariaLabel}>
							{props.value}
						</span>
						<EvTag
							icon={props.trendTag.icon}
							status={props.trendTag.status}
							text={props.trendTag.text}
							aria-label={props.trendAriaLabel}
						/>
					</div>
				)}
			</div>
		</div>
	);
};
